export default {
  title: 'Configuración de SLA',
  description:
    'Defina el SLA con base en la fecha de apertura o agendamiento para garantizar plazos de atención claros.',
  checklist: 'Cuestionario *',
  place: 'Local *',
  startCount: 'Inicio del conteo *',
  unit: 'Unidad de conteo *',
  slaValue: 'Plazo del SLA *',
  warning: 'El SLA será calculado con base en la configuración vigente en el momento de la creación de la actividad.'
}
